import React, { useEffect, useState, useRef } from "react";
import "../styles/RelatedBInput.css";
import Uploadbutton from "../icons/BusinessHub/Uploadbutton";
import Utils from "../utils/Utils.js";
import LocationIcon from "../icons/BusinessHub/LocationIcon.js";
import EmailIcon from "../icons/SignInIcon/EmailIcon.js";
import CityIcon from "../icons/BusinessHub/CityIcon.js";
import ZipCodeIcon from "../icons/BusinessHub/ZipCodeIcon.js";
import CountriesController from "../controllers/CountriesController.js";
import Select from "react-select";
import ReactCountryFlag from "react-country-flag";
import { parsePhoneNumberFromString, AsYouType } from "libphonenumber-js";
import DescriptionIcon from "../icons/BusinessHub/DescriptionIcon.js";
import LocationPicker from "./GoogleLocation.js";

function RelatedBInput({ onDataChange, selectedType }) {
  const handleLocationSelect = (locationData) => {
    // if (!country =s== null)
    setCountry(locationData.rawAddress.country);
    // // if (!City)
    setCity(locationData.city);
    // // if (!Zip)
    setZip(locationData.rawAddress.postcode);
    // // if (!Street)
    setStreet(locationData.rawAddress.road);
    // // if (!CompAddress)
    setCompAddress(locationData.rawAddress.suburb);
    // // if (!googleLocation)
    setgoogleLocation(locationData.label);
    // locationData = {
    //   plusCode, city, postal, label, lat, lon, rawAddress
    // }
  };
  const [BranchName, setBranchName] = useState("");
  const [taxNumber, setTaxNumber] = useState("");
  const [country, setCountry] = useState("");
  const [countries, setCountries] = useState([]);
  const [City, setCity] = useState("");
  const [Zip, setZip] = useState("");
  const [Street, setStreet] = useState("");
  const [CompAddress, setCompAddress] = useState("");
  const [googleLocation, setgoogleLocation] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  useEffect(() => {
    onDataChange({
      BranchName,
      googleLocation,
      taxNumber,
      // disc,
      country,
      City,
      Zip,
      Street,
      CompAddress,
    });
  }, [
    BranchName,
    googleLocation,
    taxNumber,
    country,
    City,
    Zip,
    Street,
    CompAddress,
  ]);
  useEffect(() => {
    const GetCountries = async () => {
      const res = await CountriesController.getCountries();
      if (res?.data) {
        setCountries(
          res.data.map((c) => ({
            value: c.countryCode,
            label: c.countryName,
            dialCode: c.suffix,
          })),
        );
      }
    };
    GetCountries();
  }, []);

  const formatCountryOption = (option) => (
    <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
      <ReactCountryFlag
        svg
        countryCode={option.value}
        style={{ width: "1.2em", height: "1.2em" }}
      />
      <span>{option.label}</span>
    </div>
  );
  useEffect(() => {
    if (showPicker) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPicker]);
  return (
    <div className="related-business-reg-window-container-div">
      {showPicker && (
        <div className="rel-business-location-picker">
          <LocationPicker
            onSelect={(locationData) => {
              handleLocationSelect(locationData);
              setShowPicker(false); // optional: close on selection
            }}
            onClose={() => setShowPicker(false)} // closes when close button clicked
          />
        </div>
      )}
      <div className="related-business-reg-info-input">
        <div className="related-business-reg-info-input-header">
          Company Information
        </div>
        <div className="related-business-reg-info-input-body">
          <div className="related-business-reg-info-data-input-name">
            <div className="related-business-reg-info-data-input-cont">
              {selectedType?.charAt(0).toUpperCase() +
                selectedType?.slice(1).toLowerCase()}{" "}
              Name
              <div className="required">*</div>
            </div>
            <div className="related-business-reg-info-input-data">
              <input
                className="related-business-reg-info-input-data-tag"
                value={BranchName}
                onChange={(e) => setBranchName(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="related-business-reg-info-data-input">
            <div className="related-business-reg-info-data-input-cont">
              Tax Number
              {/* <div className="required">*</div> */}
            </div>
            <div className="related-business-reg-info-input-data">
              <input
                className="related-business-reg-info-input-data-tag"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={taxNumber}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, "");
                  setTaxNumber(onlyNumbers);
                }}
              ></input>
            </div>
          </div>
        </div>
        {/* <div className="related-business-reg-info-input-body-disc">
          <div className="related-business-reg-info-data-input-email">
            <div className="related-business-reg-info-data-input-cont-disc">
              <div className="related-business-reg-icon">
                <DescriptionIcon />
              </div>
              Description<div className="required">*</div>
            </div>
            <div className="related-business-reg-info-input-data-disc">
              <textarea
                className="related-business-reg-info-input-data-tag-disc"
                value={disc}
                onChange={(e) => setdisc(e.target.value)}
              ></textarea>
            </div>
          </div>
        </div> */}
        <div className="related-business-reg-info-input-body-doc">
          <div className="related-business-reg-info-input-body-doc-title">
            Company Address
          </div>
          <div className="reg-branch-adrreses">
            <div className="country-group">
              <div className="related-business-address-location">
                <div className="related-business-reg-info-data-input-content">
                  <LocationIcon />
                  Country of Residence <span className="required">*</span>
                </div>
                <div className="country-group-container">
                  {/**********************************************************/}
                  <Select
                    className="nickname-select"
                    options={countries}
                    value={countries?.find((c) => c.label === country)}
                    onChange={(selected) => setCountry(selected.label)}
                    formatOptionLabel={formatCountryOption}
                    placeholder="Select country of residence"
                    isSearchable
                    styles={{
                      container: (base) => ({
                        ...base,
                        fontSize: "13.5px",
                        width: "95%",
                        minWidth: "210px",
                        height: "100%",
                      }),
                      control: (base, state) => ({
                        ...base,
                        border: "none",
                        backgroundColor: "transparent",
                        cursor: "pointer",
                        height: "20px",
                        width: "100%",
                        boxShadow: "none",
                        "&:hover": { border: "none" },
                      }),
                      valueContainer: (base) => ({
                        // ...base
                        display: "flex",
                        maxWidth: "190px",
                        overflowX: "auto",
                        alignItems: "center",
                        justifyContent: "center",
                      }),
                      indicatorsContainer: (base) => ({ ...base }),
                      dropdownIndicator: (base) => ({}),
                      singleValue: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                        color: "initial",
                      }),
                    }}
                  />
                  {/**********************************************************/}
                  {/* <select
                    className="nickname-select"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  >
                    <option value="" disabled>
                      Select country of residence
                    </option>
                    {countries.map((c) => (
                      <option key={c.code} value={c.label}>
                        {c.label}
                      </option>
                    ))}
                  </select> */}
                  {/**********************************************************/}
                </div>
              </div>
            </div>
            <div className="related-business-address">
              <div className="related-business-reg-info-data-input-content">
                <CityIcon />
                City <div className="required">*</div>
              </div>
              <div className="related-business-reg-info-input-data">
                <input
                  className="related-business-reg-info-input-data-tag"
                  value={City}
                  onChange={(e) => setCity(e.target.value)}
                ></input>
              </div>
            </div>
            <div className="related-business-address">
              <div className="related-business-reg-info-data-input-content">
                <ZipCodeIcon />
                Zip Code <div className="required">*</div>
              </div>
              <div className="related-business-reg-info-input-data">
                <input
                  className="related-business-reg-info-input-data-tag"
                  value={Zip}
                  onChange={(e) => setZip(e.target.value)}
                ></input>
              </div>
            </div>
          </div>
          <div className="reg-branch-adrreses">
            <div className="country-group">
              <div className="">
                <div className="">
                  <div className="related-business-reg-info-data-input-content">
                    Street Address<span className="required">*</span>
                  </div>
                  <div className="related-business-reg-info-input-data">
                    <input
                      className="related-business-reg-info-input-data-tag"
                      value={Street}
                      onChange={(e) => setStreet(e.target.value)}
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div className="related-business-reg-info-data-input-content">
                Complimentary Address
              </div>
              <div className="related-business-reg-info-input-data">
                <input
                  className="related-business-reg-info-input-data-tag"
                  value={CompAddress}
                  onChange={(e) => setCompAddress(e.target.value)}
                ></input>
              </div>
            </div>
          </div>
          <div className="reg-branch-adrreses-google">
            <div className="related-business-reg-info-data-input-content">
              Google Location
            </div>
            <div
              className="related-business-reg-info-input-data"
              style={{ cursor: "pointer" }}
              onClick={() => setShowPicker(true)}
            >
              {/* {showPicker && (
                <div style={{ color: "#424242" }}>
                  <LocationPicker
                    onSelect={(locationData) => {
                      handleLocationSelect(locationData);
                      setShowPicker(false); // optional: close on selection
                    }}
                    onClose={() => setShowPicker(false)} // closes when close button clicked
                  />
                </div>
              )} */}
              {/* {googleLocation} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RelatedBInput;
